// extracted by mini-css-extract-plugin
export var bellring = "bj_dK";
export var boxErrorContainer = "bj_dD";
export var boxErrorWrapper = "bj_dJ";
export var boxErrordanger = "bj_dH";
export var boxErrorinfo = "bj_dF";
export var boxErrorwarning = "bj_dG";